import { FilterIcon } from "assets/icons";
import { toastServerError } from "helpers";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteEnrichmentProfile, useEnrichmentProfiles } from "../../apis";
import {
  EnrichmentProfileForm,
  EnrichmentProfileList,
  SectionCard
} from "../../components";
import { CategoryEnrichmentProfile } from "../../recommendation.types";

import styles from "./EnrichmentProfiles.module.scss";

const EnrichmentProfiles = () => {
  const { t } = useTranslation();

  const { profiles, isLoading } = useEnrichmentProfiles();

  const [profileToDelete, setProfileToDelete] =
    useState<CategoryEnrichmentProfile | null>(null);

  const { mutate: deleteProfile, isLoading: isDeleting } =
    useDeleteEnrichmentProfile({
      onSuccess: () => {
        toast.success(t("Enrichment rule removed"));
        setProfileToDelete(null);
      },
      onError: toastServerError
    });

  return (
    <div className={styles.profiles}>
      <p className={styles.profiles__hint}>
        {t(
          'AI tagging is only meaningful where the purchase is an aesthetic choice. On a cable or a fan it produces six fields of noise — and gender is a hard filter, so a cable wrongly tagged "women" is silently excluded from recommendations for men\'s products. A rule attaches to one category and everything beneath it follows, until a descendant overrides it.'
        )}
      </p>

      <SectionCard icon={<FilterIcon />} title={t("Add a rule")}>
        <EnrichmentProfileForm />
      </SectionCard>

      <EnrichmentProfileList
        profiles={profiles}
        isLoading={isLoading}
        onDelete={setProfileToDelete}
      />

      <Modal
        type="delete"
        isOpen={Boolean(profileToDelete)}
        isLoading={isDeleting}
        title={t("Remove enrichment rule")}
        okText={t("Remove")}
        onClose={() => setProfileToDelete(null)}
        onOk={() =>
          profileToDelete && deleteProfile(profileToDelete.categoryId)
        }
      >
        <p className={styles.confirmText}>
          {t(
            "The branch goes back to inheriting from its nearest configured ancestor, or to the default if there is none."
          )}
        </p>
      </Modal>
    </div>
  );
};

export default EnrichmentProfiles;
